module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    class: ['location-autocomplete field-group', {
      'field-error': !!_vm.error,
      'flight-field': _vm.extra.flightInput
    }]
  }, [_vm._m(0), _vm._v(" "), (_vm.isIosDevice) ? _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.keyInput),
      expression: "keyInput"
    }],
    ref: "input",
    class: ['location-input field-text', {
      'loading': _vm.locationLoading,
      'has-error': !!_vm.error,
      'move-left': (_vm.extra.field === 'pickup' && !_vm.extraStop[_vm.leg].length && _vm.extra.hasExtraStop) || _vm.extra.field === 'extraStop'
    }],
    attrs: {
      "type": "text",
      "autocomplete": "off",
      "name": ((_vm.extra.field) + "x"),
      "readonly": _vm.readOnly,
      "placeholder": _vm.extra.placeholder,
      "disabled": _vm.disabled || _vm.locationLoading
    },
    domProps: {
      "value": (_vm.keyInput)
    },
    on: {
      "keypress": _vm.query,
      "blur": [_vm.onBlur, _vm.clickOut],
      "focus": _vm.onFocus,
      "keydown": function($event) {
        if (!('button' in $event) && _vm._k($event.keyCode, "tab", 9)) { return null; }
        _vm.onpressTab($event)
      },
      "click": _vm.onClick,
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.keyInput = $event.target.value
      }
    }
  }) : _vm._e(), _vm._v(" "), (!_vm.isIosDevice) ? _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.keyInput),
      expression: "keyInput"
    }],
    ref: "input",
    class: ['location-input field-text', {
      'loading': _vm.locationLoading,
      'has-error': !!_vm.error,
      'move-left': (_vm.extra.field === 'pickup' && !_vm.extraStop[_vm.leg].length && _vm.extra.hasExtraStop) || _vm.extra.field === 'extraStop'
    }],
    attrs: {
      "type": "text",
      "autocomplete": "off",
      "name": ((_vm.extra.field) + "x"),
      "readonly": _vm.readOnly,
      "placeholder": _vm.extra.placeholder,
      "disabled": _vm.disabled || _vm.locationLoading
    },
    domProps: {
      "value": (_vm.keyInput)
    },
    on: {
      "keyup": _vm.query,
      "blur": [_vm.onBlur, _vm.clickOut],
      "focus": _vm.onFocus,
      "keydown": function($event) {
        if (!('button' in $event) && _vm._k($event.keyCode, "tab", 9)) { return null; }
        _vm.onpressTab($event)
      },
      "click": _vm.onClick,
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.keyInput = $event.target.value
      }
    }
  }) : _vm._e(), _vm._v(" "), _c('span', {
    staticClass: "field-error-message"
  }, [_vm._v(_vm._s(_vm.error))]), _vm._v(" "), (_vm.extra.field === 'pickup' && !_vm.extraStop[_vm.leg].length && !_vm.disabled && _vm.extra.hasExtraStop) ? _c('div', {
    staticClass: "add-stop",
    on: {
      "click": function($event) {
        _vm.toggleExtraStop(_vm.extra.field)
      }
    }
  }, [_c('i', {
    staticClass: "fas fa-plus",
    on: {
      "mouseover": function($event) {
        _vm.extraStopHover = true
      },
      "mouseleave": function($event) {
        _vm.extraStopHover = false
      }
    }
  }), _vm._v(" "), _c('transition', {
    attrs: {
      "name": "slide-up"
    }
  }, [_c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.extraStopHover),
      expression: "extraStopHover"
    }]
  }, [_vm._v(_vm._s(_vm.$t('searchForm.youCanAdd')))])])], 1) : _vm._e(), _vm._v(" "), (_vm.extra.field === 'extraStop' && _vm.extraStop[_vm.leg].length && !_vm.disabled) ? _c('div', {
    staticClass: "add-stop",
    on: {
      "click": function($event) {
        _vm.toggleExtraStop(_vm.extra.field)
      }
    }
  }, [_c('i', {
    staticClass: "fas fa-minus"
  })]) : _vm._e(), _vm._v(" "), _c('i', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.locationLoading || _vm.loading),
      expression: "locationLoading || loading"
    }],
    class: ['fa fa-spinner fa-spin loaderx fa-2x', {
      'move-left': (_vm.extra.field === 'pickup' && !_vm.extraStop[_vm.leg].length && _vm.extra.hasExtraStop) || _vm.extra.field === 'extraStop'
    }]
  }), _vm._v(" "), _c('transition', {
    attrs: {
      "name": "slide-down"
    }
  }, [_c('ul', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.showSuggestion),
      expression: "showSuggestion"
    }],
    staticClass: "location-suggestions"
  }, _vm._l((_vm.suggestions), function(item, index) {
    return _c('li', {
      key: index,
      class: {
        'empty': item.title === 'Sorry', 'select-item': index === _vm.selectIndex
      },
      on: {
        "click": function($event) {
          _vm.selectLocation(index)
        }
      }
    }, [_c('i', {
      class: ['fas', item.icon]
    }), _vm._v(" "), _c('span', {
      domProps: {
        "innerHTML": _vm._s(item.subtitle ? item.subtitle : item.title)
      }
    })])
  }))]), _vm._v(" "), _c('transition', {
    attrs: {
      "name": "slide-down"
    }
  }, [_c('ul', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.showStaticLocations && _vm.focusing && _vm.lastLoc.length && _vm.extra.type !== 'location'),
      expression: "showStaticLocations && focusing && lastLoc.length && extra.type !== 'location'"
    }],
    staticClass: "static-location"
  }, _vm._l((_vm.lastLoc), function(loc, i) {
    return _c('li', {
      key: i,
      on: {
        "click": function($event) {
          _vm.selectLoc(loc)
        }
      }
    }, [_c('i', {
      staticClass: "fas fa-clock"
    }), _vm._v(" " + _vm._s(loc.title) + "\n      ")])
  }))])], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticStyle: {
      "display": "none"
    }
  }, [_c('input', {
    attrs: {
      "type": "text"
    }
  }), _vm._v(" "), _c('input', {
    attrs: {
      "type": "password"
    }
  })])
}]}
module.exports.render._withStripped = true
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-4ee66942", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-4ee66942","transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Search/LocationInput.vue
// module id = 2090
// module chunks = 0